import { useParams } from 'react-router';
import { resetLocalStorage } from '../utils';

const LAST_VISITED_ORGANIZATION_KEY = 'lastVisitedOrganizationId';

/**
 * Clears persisted filters whenever the active organization changes,
 * no matter which navigation path triggered the switch (header buttons,
 * organization card, deep link, browser history).
 *
 * Runs synchronously during render so the storage is already cleared
 * before the page components read their initial filter state.
 */
export function useResetFiltersOnOrganizationChange() {
  const { organizationId } = useParams<{ organizationId?: string }>();

  if (!organizationId || organizationId === 'undefined') {
    return;
  }

  const lastVisitedOrganizationId = localStorage.getItem(
    LAST_VISITED_ORGANIZATION_KEY,
  );

  if (lastVisitedOrganizationId === organizationId) {
    return;
  }

  if (lastVisitedOrganizationId) {
    resetLocalStorage();
  }

  localStorage.setItem(LAST_VISITED_ORGANIZATION_KEY, organizationId);
}
